import { useEffect, useState } from "react";
import { QrCode } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common/Loader";
import { PageHeader, EmptyState } from "@/components/dashboard/ui";
import { QRCard } from "@/components/dashboard/QRCard";

export default function QRCodes() {
  const { user } = useAuth();
  const studioName = user?.business_name || user?.name;
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data.events)).catch(() => setEvents([])); }, []);
  if (!events) return <Loader />;

  return (
    <div>
      <PageHeader title="QR Codes" subtitle="Printable, shareable QR codes for every event gallery." />
      {events.length === 0 ? <EmptyState icon={QrCode} title="No QR codes yet" desc="Create an event to generate its unique QR code." /> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
          {events.map((e) => (
            <div key={e.id} data-testid={`qr-event-${e.id}`}>
              <QRCard event={e} link={`${window.location.origin}/event/${e.id}`} studioName={studioName} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
